<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true" class="filter-bar">
      <el-form-item label="门店名称" size="small">
        <el-input
          v-model="listQuery.store_name"
          placeholder="请输入账号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" size="small">
        <el-input
          v-model="listQuery.boss_name"
          placeholder="请输入联系人姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="门店电话" size="small">
        <el-input
          v-model="listQuery.store_phone"
          placeholder="请输入账号"
          clearable
        ></el-input>
      </el-form-item>
      <el-button type="primary" size="small" v-waves @click="handleSearch"
        >搜索</el-button
      >
      <el-button type="primary" size="small" v-waves class="add-btn" @click="handleAdd"
        >新增门店</el-button
      >
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="storeName" slot-scope="{ row }">
          <div class="store-name-cell">
            <div class="store-avatar">
              <i class="el-icon-user-solid"></i>
            </div>
            <span class="store-name-text">{{ row.store_name }}</span>
          </div>
        </template>
        <template slot="tag" slot-scope="{ row }">
          <span class="store-tag" :class="'tag-' + row.tagType">{{
            row.tag
          }}</span>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" class="op-link" @click="send(row)"
              >营销通知</el-button
            >
            <el-button size="mini" class="op-edit" @click="handleEdit(row)"
              >编辑</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 右侧滑出抽屉表单 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="480px"
      :wrapper-closable="false"
      custom-class="store-drawer"
    >
      <div class="drawer-body">
        <!-- 档案头：头像 + 名称/手机号 -->
        <div class="drawer-profile">
          <div class="profile-avatar"><i class="el-icon-user-solid"></i></div>
          <div class="profile-info">
            <div class="profile-name">{{ dialogForm.store_name || "未命名门店" }}</div>
            <div class="profile-phone">{{ dialogForm.store_phone || "暂未填写" }}</div>
          </div>
        </div>

        <!-- 步骤条 -->
        <div class="step-bar">
          <div
            v-for="(step, i) in stepList"
            :key="step"
            class="step-item"
            :class="{
              done: i <= currentStep,
              current: i === currentStep,
              first: i === 0,
            }"
            >{{ step }}</div
          >
        </div>

        <!-- 跟进状态 -->
        <div class="follow-bar">
          <div class="follow-info" :class="{ 'info-inline': isAllDone }">
            <div class="follow-title">跟进状态</div>
            <div class="follow-next">
              {{ isAllDone ? "已全部完成" : "下一步：" + nextStepName }}
            </div>
          </div>
          <el-button
            v-if="!isAllDone"
            class="btn-follow"
            type="primary"
            @click="handleFollow"
            >完 成</el-button
          >
        </div>

        <!-- 礼花特效画布 -->
        <canvas ref="confetti" class="confetti-canvas"></canvas>

        <div class="feed-divider"></div>

        <!-- 客户资料 -->
        <div class="drawer-section">
          <div class="section-title">客户资料</div>

          <!-- 标签 -->
          <div class="chip-row">
            <span class="row-label">标签</span>
            <div class="chip-list">
              <span
                v-for="t in tagOptions"
                :key="t.text"
                class="chip"
                :class="[
                  'chip-' + t.type,
                  { selected: selectedTags.includes(t.text) },
                ]"
                @click="toggleTag(t.text)"
              >
                {{ t.text }}
              </span>
            </div>
          </div>

          <!-- 来源 -->
          <div class="chip-row">
            <span class="row-label">来源</span>
            <div class="chip-list">
              <span
                v-for="s in sourceOptions"
                :key="s"
                class="chip chip-source"
                :class="{ selected: dialogForm.source === s }"
                @click="dialogForm.source = s"
              >
                {{ s }}
              </span>
            </div>
          </div>

          <!-- 保留字段 -->
          <el-form ref="form" :model="dialogForm" class="store-form">
            <div class="field-row">
              <span class="row-label">门店名称</span>
              <el-input
                v-model="dialogForm.store_name"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
            <div class="field-row">
              <span class="row-label">姓名</span>
              <el-input
                v-model="dialogForm.boss_name"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
            <div class="field-row">
              <span class="row-label">手机号</span>
              <el-input
                v-model="dialogForm.store_phone"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
            <div class="field-row">
              <span class="row-label">店铺地址</span>
              <el-input
                v-model="dialogForm.store_addr"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
          </el-form>

          <!-- 照片占位 -->
          <div class="photo-grid">
            <div class="photo-block">
              <div class="photo-label">门店照片</div>
              <div class="photo-card">
                <div class="photo-slot" v-for="n in 4" :key="n"></div>
              </div>
            </div>
            <div class="photo-block">
              <div class="photo-label">营业执照</div>
              <div class="photo-card">
                <div class="photo-slot wide"></div>
              </div>
            </div>
          </div>

        </div>

        <!-- 动态时间线 -->
        <div class="feed-divider"></div>
        <div class="feed-tabs">
          <span
            v-for="t in feedTabs"
            :key="t"
            class="feed-tab"
            :class="{ active: activeFeed === t }"
            @click="activeFeed = t"
            >{{ t }}</span
          >
        </div>
        <div class="feed-list">
          <div class="feed-item" v-for="(item, i) in currentFeedList" :key="i">
            <span class="feed-dot"></span>
            <div class="feed-main">
              <div class="feed-head">
                <span class="feed-title">{{ item.title }}</span>
                <span class="feed-time">{{ item.time }}</span>
              </div>
              <div class="feed-action">{{ item.action }}</div>
              <div class="feed-operator">操作人：{{ item.operator }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="btn-confirm" type="primary" @click="save">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import {
  selectStore,
  addStore,
  updateStore,
} from "@/services/mini/store";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  beforeDestroy() {
    if (this.confettiTimer) cancelAnimationFrame(this.confettiTimer);
  },
  // directives: {
  //   waves,
  // },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      /* 跟进步骤条 */
      stepList: ["新线索", "电话沟通", "添加微信", "产品演示", "已完成"],
      currentStep: 0,
      confettiTimer: null,
      /* 标签 / 来源 */
      tagOptions: [
        { text: "新用户", type: "red" },
        { text: "A类", type: "green" },
        { text: "B类", type: "yellow" },
        { text: "C类", type: "gray" },
      ],
      selectedTags: ["新用户"],
      sourceOptions: ["小程序搜索", "老用户介绍", "自然流量"],
      /* 动态时间线 */
      feedTabs: ["全部", "客户动态", "员工变动记录"],
      activeFeed: "全部",
      /* 客户动态 */
      feedList: [
        {
          title: "用户小程序搜索",
          action: "改为新线索",
          operator: "vv",
          time: "2025-09-10 22:33:00",
        },
        {
          title: "用户授权手机号",
          action: "改为新线索",
          operator: "vv",
          time: "2025-09-10 22:33:00",
        },
        {
          title: "客户完成首单",
          action: "升级为成交客户",
          operator: "店长张涛",
          time: "2025-08-28 15:02:11",
        },
      ],
      /* 员工变动记录 */
      employeeList: [
        {
          title: "员工入职",
          action: "李静 加入门店，岗位：店员",
          operator: "人事王敏",
          time: "2026-03-12 09:15:00",
        },
        {
          title: "岗位调整",
          action: "刘强 由店员调整为店长",
          operator: "区域经理赵磊",
          time: "2025-12-05 10:40:00",
        },
        {
          title: "门店调动",
          action: "陈晨 由旗舰店调至本门店",
          operator: "人事王敏",
          time: "2025-11-18 16:22:00",
        },
        {
          title: "员工离职",
          action: "孙宇 离职，原因：个人原因",
          operator: "人事王敏",
          time: "2025-10-09 11:05:00",
        },
      ],
    };
  },
  computed: {
    listHeader,
    nextStepName() {
      return this.stepList[this.currentStep + 1] || "已全部完成";
    },
    /* 是否已全部完成 */
    isAllDone() {
      return this.currentStep >= this.stepList.length - 1;
    },
    /* 当前 Tab 对应的动态列表 */
    currentFeedList() {
      if (this.activeFeed === "客户动态") return this.feedList;
      if (this.activeFeed === "员工变动记录") return this.employeeList;
      /* 全部：合并后按时间倒序 */
      return [...this.feedList, ...this.employeeList].sort(
        (a, b) => new Date(b.time) - new Date(a.time)
      );
    },
  },
  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectStore(
        listQuery || this.listQuery
      );
      if (code === 200) {
        /* 标签 / 来源 / 状态 为模拟数据，按行号稳定分配 */
        const tags = [
          { text: "新用户", type: "red" },
          { text: "B类", type: "yellow" },
          { text: "C类", type: "gray" },
          { text: "A类", type: "green" },
        ];
        const statuses = ["使用中", "使用中", "未使用", "待续费"];
        this.tableData = (data || []).map((row, i) => ({
          ...row,
          tag: tags[i % tags.length].text,
          tagType: tags[i % tags.length].type,
          source: "搜索",
          status: statuses[i % statuses.length],
        }));
        this.listQuery.total = count;
        this.loading = false;
      }
    },
    /* 搜索按钮 */
    async handleSearch() {
      this.getListData();
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建门店";
      this.dialogForm = {};
      this.currentStep = 0;
      this.selectedTags = [];
      this.activeFeed = "全部";
    },

    /* 通知续费 */
    send() {
      this.$message({
        type: "error",
        message: "该功能暂未开通!",
      });
    },

    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑门店";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.currentStep = 0;
      this.selectedTags = row.tag ? [row.tag] : [];
      this.activeFeed = "全部";
    },

    /* 切换标签选中 */
    toggleTag(text) {
      const i = this.selectedTags.indexOf(text);
      if (i > -1) {
        this.selectedTags.splice(i, 1);
      } else {
        this.selectedTags.push(text);
      }
    },

    /* 完成跟进，推进步骤；全部完成时放礼花 */
    handleFollow() {
      if (this.currentStep < this.stepList.length - 1) {
        this.currentStep += 1;
        if (this.currentStep === this.stepList.length - 1) {
          this.$nextTick(() => {
            this.fireConfetti();
          });
        }
      }
    },

    /* 礼花特效：两侧对角上抛的彩色纸屑 */
    fireConfetti() {
      const canvas = this.$refs.confetti;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const dpr = window.devicePixelRatio || 1;
      const width = canvas.clientWidth || 480;
      const height = canvas.clientHeight || 600;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const colors = [
        "#3D8DFC",
        "#00B42A",
        "#F53F3F",
        "#F5BE15",
        "#E6A23C",
        "#9C6BFF",
      ];
      const particles = [];
      const total = 140;
      for (let i = 0; i < total; i++) {
        const fromLeft = i % 2 === 0;
        particles.push({
          x: fromLeft ? 12 : width - 12,
          y: height - (Math.random() * 40 + 20),
          vx: fromLeft ? Math.random() * 5 + 2 : -(Math.random() * 5 + 2),
          vy: -(Math.random() * 9 + 7),
          size: Math.random() * 6 + 4,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.4,
        });
      }

      if (this.confettiTimer) cancelAnimationFrame(this.confettiTimer);
      const gravity = 0.22;
      let frames = 0;
      const draw = () => {
        ctx.clearRect(0, 0, width, height);
        let alive = 0;
        particles.forEach((p) => {
          p.vy += gravity;
          p.vx *= 0.995;
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += p.vr;
          if (p.y < height + 30) alive += 1;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
          ctx.restore();
        });
        frames += 1;
        if (alive > 0 && frames < 300) {
          this.confettiTimer = requestAnimationFrame(draw);
        } else {
          ctx.clearRect(0, 0, width, height);
          this.confettiTimer = null;
        }
      };
      draw();
    },

    /* 保存 */
    save() {
      if (this.dialogName === "创建门店") {
        addStore(this.dialogForm).then((res) => {
          console.log("创建门店", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑门店") {
        updateStore(this.dialogForm).then((res) => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 28px 16px 12px;
  margin: 0;

  .add-btn {
    margin-left: 16px;
    background: #3d8dfc;
    border-color: #3d8dfc;
  }
  /deep/ .el-form-item {
    margin-right: 20px;
    .el-input__inner {
      width: 180px;
    }
  }
  > .el-button--primary:last-of-type {
    background: #3d8dfc;
    border-color: #3d8dfc;
  }
}
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;
}

/* 门店名称单元格：头像 + 名称 */
.store-name-cell {
  display: flex;
  align-items: center;
}
.store-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e5e6eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  i {
    color: #fff;
    font-size: 16px;
  }
}
.store-name-text {
  color: #1d2129;
}

/* 标签 */
.store-tag {
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 10px;
  border-radius: 4px;
  &.tag-red {
    background: #fde8e8;
    color: #f53f3f;
  }
  &.tag-yellow {
    background: #fff3d6;
    color: #d48806;
  }
  &.tag-green {
    background: #e8ffea;
    color: #00b42a;
  }
  &.tag-gray {
    background: #f2f3f5;
    color: #86909c;
  }
}

/* 右侧滑出抽屉：按 UI 设计稿样式 */
/deep/ .el-drawer__body {
  position: relative;
  padding: 0 0 64px;
}
/deep/ .store-drawer .el-drawer__header {
  padding: 16px 20px;
  margin-bottom: 0;
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
}
/deep/ .store-drawer .el-drawer__close-btn {
  color: #86909c;
}

.drawer-body {
  height: 100%;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 0 20px;
}

/* 档案头：头像 + 名称/手机号 */
.drawer-profile {
  display: flex;
  align-items: center;
  padding-bottom: 16px;

  .profile-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #e5e6eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .profile-name {
    font-size: 16px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
  }
  .profile-phone {
    font-size: 13px;
    color: #86909c;
    line-height: 18px;
    margin-top: 2px;
  }
}

/* 步骤条：箭头形 */
.step-bar {
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
}
.step-item {
  flex: 1;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 13px;
  color: #4e5969;
  background: #f2f3f5;
  clip-path: polygon(
    0 0,
    calc(100% - 8px) 0,
    100% 50%,
    calc(100% - 8px) 100%,
    0 100%,
    8px 50%
  );
  white-space: nowrap;
  overflow: hidden;

  &.first {
    clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%);
  }
  /* 已完成：填充蓝色 */
  &.done {
    background: #3d8dfc;
    color: #fff;
  }
  /* 当前所在步骤：加深蓝 + 加粗 */
  &.current {
    background: #2f7be0;
    color: #fff;
    font-weight: 600;
  }
}

/* 跟进状态 */
.follow-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;

  .follow-title {
    font-size: 15px;
    font-weight: 600;
    color: #1d2129;
  }
  .follow-next {
    margin-top: 6px;
    font-size: 13px;
    color: #4e5969;
  }
  /* 全部完成时：标题与状态文案并排 */
  .follow-info.info-inline {
    display: flex;
    align-items: baseline;
    gap: 8px;

    .follow-next {
      margin-top: 0;
    }
  }
  .btn-follow {
    height: 32px;
    padding: 0 20px;
    font-size: 14px;
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    border-radius: 6px;
    transition: all 0.15s ease;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}

/* 礼花画布：覆盖抽屉内容区，不拦截点击 */
.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99;
}

/* 分区标题：加粗 + 细分隔线 */
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f1f3;
  margin-bottom: 16px;
}

/* 标签 / 来源 */
.chip-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.row-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}
.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  background: #f2f3f5;
  color: #4e5969;
  border: 1px solid transparent;
  transition: all 0.15s ease;

  /* 彩色标签：浅色底 + 同色文字 */
  &.chip-red {
    background: #fdecee;
    color: #f53f3f;
  }
  &.chip-green {
    background: #e8f8ee;
    color: #00b42a;
  }
  &.chip-yellow {
    background: #fdf3e1;
    color: #e6a23c;
  }
  &.chip-gray {
    background: #f2f3f5;
    color: #a9aeb8;
  }

  /* 来源：白底描边 */
  &.chip-source {
    background: #fff;
    color: #1d2129;
    border-color: #e5e6eb;
  }
  &.chip-source.selected {
    color: #3d8dfc;
    border-color: #3d8dfc;
  }

  /* 选中态：同色描边 + 右下角对勾折角 */
  &.selected {
    border-color: currentColor;
  }
  &.selected::before {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    border-style: solid;
    border-width: 0 0 22px 22px;
    border-color: transparent transparent currentColor transparent;
    border-bottom-right-radius: 7px;
  }
  &.selected::after {
    content: "✓";
    position: absolute;
    right: 0;
    bottom: 0;
    /* 与折角等大，先居中再向右下偏移到三角形重心 */
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(4px, 4px);
    font-size: 14px;
    line-height: 1;
    font-weight: 700;
    color: #fff;
  }
}

/* 保留字段行 */
.field-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  .el-input {
    flex: 1;
  }
}
.store-form /deep/ .el-input__inner {
  background: #f2f3f5;
  border: none;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  color: #1d2129;
  font-size: 14px;

  &::placeholder {
    color: #a9aeb8;
  }
}

/* 照片占位 */
.photo-grid {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 16px;
  margin: 4px 0 16px;
  align-items: stretch;
}
.photo-block {
  display: flex;
  flex-direction: column;
}
.photo-label {
  font-size: 13px;
  font-weight: 500;
  color: #1d2129;
  margin-bottom: 10px;
}
.photo-card {
  flex: 1;
  background: #f2f3f5;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 10px;
  min-height: 88px;
  align-items: flex-start;

  .photo-slot {
    flex: 1 1 0;
    min-width: 0;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(29, 33, 41, 0.04);
    /* 白色块为正方形 */
    aspect-ratio: 1 / 1;
  }

  /* 营业执照：固定高度，不随卡片拉伸 */
  .photo-slot.wide {
    align-self: flex-start;
    aspect-ratio: auto;
    height: 72px;
    min-height: 0;
  }
}

/* 动态时间线 */
.feed-divider {
  height: 8px;
  background: #f2f3f5;
  margin: 20px -20px;
}
.feed-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;

  .feed-tab {
    font-size: 14px;
    color: #4e5969;
    cursor: pointer;

    &.active {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}
.feed-list {
  .feed-item {
    position: relative;
    display: flex;
    padding-bottom: 20px;

    &::before {
      content: "";
      position: absolute;
      left: 5px;
      top: 16px;
      bottom: 0;
      width: 1px;
      background: #e5e6eb;
    }
    &:last-child::before {
      display: none;
    }

    .feed-dot {
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: #3d8dfc;
      margin: 4px 12px 0 0;
      flex-shrink: 0;
      position: relative;
      z-index: 1;
    }
    .feed-main {
      flex: 1;
    }
    .feed-head {
      display: flex;
      justify-content: space-between;

      .feed-title {
        font-size: 14px;
        font-weight: 500;
        color: #1d2129;
      }
      .feed-time {
        font-size: 12px;
        color: #86909c;
      }
    }
    .feed-action {
      margin-top: 6px;
      font-size: 13px;
      color: #1d2129;
    }
    .feed-operator {
      margin-top: 4px;
      font-size: 12px;
      color: #86909c;
    }
  }
}

/* 底部固定操作栏：圆角蓝色确定按钮 */
.drawer-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 12px 20px;
  border-top: 1px solid #f0f1f3;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  /* 取消 / 确定：统一胶囊样式 */
  .btn-cancel,
  .btn-confirm {
    height: 36px;
    min-width: 104px;
    border-radius: 6px;
    font-size: 14px;
    padding: 0;
    transition: all 0.15s ease;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #dcdee3;
    color: #4e5969;

    &:hover {
      color: #1d2129;
      border-color: #c9cdd4;
      background: #f7f8fa;
    }
  }
  .btn-confirm {
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    color: #fff;
    margin-left: 12px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}

.operation {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-button {
    margin: 0;
    padding: 0 12px;
    height: 24px;
    line-height: 1;
    font-size: 13px;
    border: 1px solid transparent;
    background: transparent;
    box-sizing: border-box;
    /* 文字在按钮内垂直水平居中 */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
  }
  .op-link {
    color: #3d8dfc;

    &:hover {
      color: #5aa3ff;
    }
  }
  /* 编辑：实心蓝色按钮 */
  .op-edit {
    color: #fff;
    border-color: #3d8dfc;
    background: #3d8dfc;
    border-radius: 4px;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
    }
  }
}
</style>
